// extracted by mini-css-extract-plugin
export default {"imagePopup":"imagePopup--EPcQg","show":"show--PNnvm","overlay":"overlay--e94oX","popupWrapper":"popupWrapper--LYf0k","image":"image--aHQkM","closeBtn":"closeBtn--J9UX0"};